<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>The Life and Science of</h1>
<h1 class="bk" style="margin-top:0;">HAROLD C. UREY</h1>
<p class="fig"><img alt="" height="250" src="images/Shindell_TitlepageImage.jpg" width="250"/></p>
<p class="bkau">Matthew Shindell</p>
<p class="bkpub">The University of Chicago Press   •   Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-shindell-0004.vue?3d092780